
import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* 学院情報 */}
          <div>
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: 'Pacifico, serif' }}>
              NextStyle
            </h3>
            <p className="text-gray-300 mb-4">
              「正解はひとつじゃない」を学べる学校<br />
              100人の生徒へ、100通り以上の未来を
            </p>
            <div className="flex space-x-4">
              <i className="ri-facebook-fill text-2xl text-gray-400 hover:text-white cursor-pointer transition-colors"></i>
              <i className="ri-twitter-x-fill text-2xl text-gray-400 hover:text-white cursor-pointer transition-colors"></i>
              <i className="ri-instagram-fill text-2xl text-gray-400 hover:text-white cursor-pointer transition-colors"></i>
              <i className="ri-youtube-fill text-2xl text-gray-400 hover:text-white cursor-pointer transition-colors"></i>
            </div>
          </div>

          {/* クイックリンク */}
          <div>
            <h4 className="text-lg font-semibold mb-4">クイックリンク</h4>
            <ul className="space-y-2">
              <li><a href="#about" className="text-gray-300 hover:text-white transition-colors cursor-pointer">学院について</a></li>
              <li><a href="#features" className="text-gray-300 hover:text-white transition-colors cursor-pointer">3大特長</a></li>
              <li><a href="#courses" className="text-gray-300 hover:text-white transition-colors cursor-pointer">コース一覧</a></li>
              <li><a href="#contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer">お問い合わせ</a></li>
            </ul>
          </div>

          {/* お問い合わせ情報 */}
          <div>
            <h4 className="text-lg font-semibold mb-4">お問い合わせ</h4>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-center">
                <i className="ri-phone-fill mr-2"></i>
                <span>0120-123-456</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-fill mr-2"></i>
                <span>info@nextstyle-school.jp</span>
              </div>
              <div className="flex items-center">
                <i className="ri-time-fill mr-2"></i>
                <span>平日 9:00-18:00</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 ネクストスタイル高等学院. All rights reserved. | 
            <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors ml-2 cursor-pointer">
              Web Design
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
